<template>
  <div v-if="isOpen" class="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
    <div class="bg-white p-6 rounded-lg shadow-lg w-11/12 h-auto max-h-[90vh] overflow-auto">
      <h2 class="text-xl font-semibold mb-4">{{ title }}</h2>
      <form @submit.prevent="submitForm">
        <div v-if="fields.length">
          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            <div v-for="(field, index) in fields" :key="index" class="mb-4">
              <label v-if="field.type !== 'label'" class="block text-sm font-medium mb-2">
                {{ field.label }}:
              </label>
              <div v-if="field.type === 'textarea'">
                <textarea v-model="form[field.model]" :placeholder="field.placeholder"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"></textarea>
              </div>

              <div v-else-if="field.type === 'select'">
                <select v-model="form[field.model]"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  @change="handleSelectChange(field.model, form[field.model])">
                  <option value="" disabled selected>
                    Selecciona una opción
                  </option>
                  <option v-for="(option, idx) in field.options" :key="idx" :value="option.value">
                    {{ option.label }}
                  </option>
                </select>
              </div>

              <div v-else-if="field.type === 'password'">
                <input type="password" v-model="form[field.model]" :placeholder="field.placeholder"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
              </div>

              <div v-else-if="field.type === 'checkbox'" class="flex items-center justify-center bg-gray-50">
                <input type="checkbox" v-model="form[field.model]"
                  class="appearance-none w-6 h-6 bg-gray-100 border-2 border-gray-300 rounded-lg checked:bg-blue-600 focus:ring-blue-500 focus:ring-2 cursor-pointer transform scale-150" />
              </div>

              <div v-else-if="field.type === 'number'">
                <input type="number" v-model="form[field.model]" :placeholder="field.placeholder" step="any"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
              </div>

              <div v-else-if = "field.type !== 'label'">
                <input :type="field.type || 'text'" :placeholder="field.placeholder" v-model="form[field.model]"
                  @input="calculate(field.model)"
                  class="w-full px-3 py-2 border border-gray--300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" />
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <p class="text-sm text-gray-500">No hay campos disponibles.</p>
        </div>

        <div class="flex justify-end gap-3 mt-4">
          <button type="submit"
            class="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50">
            {{ submitButtonText }}
          </button>
          <button type="button" @click="closeModal"
            class="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50">
            Cancelar
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "Nuevo",
    },
    fields: {
      type: Array,
      required: true,
    },
    submitButtonText: {
      type: String,
      default: "Guardar",
    },
  },
  data() {
    return {
      form: {},
    };
  },
  methods: {
    calculate(model) {
      if (model === 'utilidad' || model === 'costo') {
        if (this.form['utilidad'] !== undefined && this.form['costo'] !== undefined) {
          const utilidad = parseFloat(this.form['utilidad']) || 0;
          const costo = parseFloat(this.form['costo']);
          const precio_venta = costo/((100-utilidad)/100);
          this.form['utilidadE'] = (precio_venta - costo).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          this.form['precioventa'] = parseFloat(precio_venta).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
      }
    },
    closeModal() {
      this.$emit("close");
    },
    submitForm() {
      if(this.form['utilidadE'] !== undefined && this.form['precioventa'] !== undefined){
        this.form['utilidadE'] = parseFloat(this.form['utilidadE'].replace(/,/g, ''));
        this.form['precioventa'] = parseFloat(this.form['precioventa'].replace(/,/g, ''));
      }
      
      this.$emit("submit", this.form);
    },
    resetForm() {
      this.fields.forEach((field) => {
        this.form[field.model] || "";
      });
    },
    handleSelectChange(model, value) {
      if (this.title === 'Agregar Producto') {
        if (model === 'familia') {
          this.form['categoría'] = undefined;
          this.form['Codigo'] = '';
          this.$emit('familia-change', value);
        }
        if (model === 'categoría') {
          this.form['subcategoría'] = undefined;
          this.$emit('categoria-change', this.form['familia'], value);
        }
        if (this.form['categoría'] !== undefined) {
          let ruta = `${this.form['familia']}/${this.form['categoría']}/${this.form['subcategoría']}`
          if (this.form['subcategoría'] === undefined)
            ruta = `${this.form['familia']}/${this.form['categoría']}/${null}`;
          this.$axios.get(`/getConsecutivo/${ruta}`).then(response => {
            this.form['Codigo'] = response.data.identificador;
          });
        }
        if (model === 'unidad') {
          this.form['unidad'] = value;
        }
      } else {
        if (model === 'familia') {
          this.$emit('familia-change', value);
        }
      }
    },
  },
  watch: {
    isOpen: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.resetForm();
        }
      },
    },
  },
  mounted(){
    if( this.title === 'Agregar Producto' ){
      this.form['importacion'] = false;
      this.form['inventario'] = 0;
    }
    
  }
};
</script>
